import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoiceMode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceMode"><Path d="M21.5 8.5V11.5M18.5 3.5V16.5M15.5 6.65625V10M12.5 4.5V8.625" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Circle cx="6.5" cy="15.5" r="2" stroke="currentColor"/><Path d="M11.5 11.5H6.5C4.29086 11.5 2.5 13.2909 2.5 15.5C2.5 17.7091 4.29086 19.5 6.5 19.5H11.5C13.7091 19.5 15.5 17.7091 15.5 15.5C15.5 13.2909 13.7091 11.5 11.5 11.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconVoiceMode;
